import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

function InsurancesProfileComponent(props) {
  const { provider } = props;
  return (
    (provider.insurances &&
      provider.insurances
      .sort((a, b) => a.name.localeCompare(b.name)) 
        .map(item => {
          return (
            <Typography>
              <span>{item.name}</span>
            </Typography>
          );
        })) ||
    null
  );
}

InsurancesProfileComponent.PropTypes = {
  provider: PropTypes.func,
};

export default InsurancesProfileComponent;
